export enum IntervalTypes {
  CURRENT_DAY = 'CURRENT_DAY',
  YESTERDAY = 'YESTERDAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  CURRENT_MONTH = 'CURRENT_MONTH',
  CURRENT_YEAR = 'CURRENT_YEAR',
  CUSTOM = 'CUSTOM',

  CUSTOM_HOURS = 'CUSTOM_HOURS',
  CUSTOM_24_HOURS = 'CUSTOM_24_HOURS',
  CUSTOM_DAY = 'CUSTOM_DAY',
  CUSTOM_DAYS = 'CUSTOM_DAYS',
  CUSTOM_MONTHS = 'CUSTOM_MONTHS',
  CUSTOM_YEAR = 'CUSTOM_YEAR'
}
